import Abstract from "../../../../abstract-view/abstract.js";

import {
  fieldsetTrigger
} from "../../../../../mixins/fieldset-trigger.js";

export default class SliderWrapper extends Abstract {
  constructor(element) {
    super();

    this._element = element;
    this._inputFromElement = null;
    this._inputToElement = null;
  }

  getInputFromElement() {
    if (!this._inputFromElement) {
      this._inputFromElement = this._element.querySelector(`.filter-input_from`);
    }

    return this._inputFromElement;
  }

  getInputToElement() {
    if (!this._inputToElement) {
      this._inputToElement = this._element.querySelector(`.filter-input_to`);
    }

    return this._inputToElement;
  }

  getElementDataset() {
    return this._element.dataset;
  }

  getName() {
    return this.getInputFromElement().name;
  }
}

Object.assign(SliderWrapper.prototype, fieldsetTrigger);
